import { fg } from '@atlassian/jira-feature-gating';
import { boardResource } from '@atlassian/jira-router-resources-board-resource/src/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const conditionalBoardResource = resourceWithCondition(
	() => !fg('critical_board_query_with_relay'),
	boardResource,
);
